<template>
	<div>
		<div class="leaderBox" v-if="showOrhide">
			<div class="newtext">新手指引</div>
			<img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
			<img src="../../../assets/images/h1.png" class="steps step1" v-if="status==1">
			<img src="../../../assets/images/h2.png" class="steps step2" v-if="status==2">
			<img src="../../../assets/images/h3.png" class="steps step3" v-if="status==3">
			<img src="../../../assets/images/h4.png" class="steps step4" v-if="status==4">
			<img src="../../../assets/images/h5.png" class="steps step5" v-if="status==5">
			<div class="stepbtn" @click="nextStep(status)">
				{{status==1?"下一步":status==2?"下一步":status==3?"下一步":status==4?"下一步":status==5?"我知道了":"我知道了"}}
			</div>
         <div class="bottomTip">
				<el-checkbox v-model="checked">下次不再提示</el-checkbox>
			</div>
		</div>
<!--		<breadcrumb :routerList="[{to:'/contract-list',title:'合同管理'},{title:'合同列表'}]"/>-->
    <Breadtabsheader/>
		<div class="h-content">
			<div class="h-piece">
				<div class="h-formBox">
					<el-form :inline="true" :model="q" class="demo-form-inline h-formBorder" ref="form">
						<div class="h-thirdColumn w-newColumn">
							<el-form-item label="合同编号" prop="idLike">
								<el-input v-model="q.idLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="客户名称" prop="customerNameLike">
								<el-input v-model="q.customerNameLike" placeholder="请输入"></el-input>
							</el-form-item>
							<el-form-item label="销售渠道" prop="salechannelCodeLike">
								<brselect category="sales_region" :v="q.salechannelCodeLike" v-model="q.salechannelCodeLike" clearable style="width:100%"/>
							</el-form-item>
							<el-form-item class="right-btn">
								<el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
								<el-button @click="resetData" class="h-btn h-formBtn h-bgwhite">重置</el-button>
								<el-button v-auth="'createContract'" class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="xinzenghetong">新增合同</el-button>
							</el-form-item>
						</div>
					</el-form>
				</div>

			</div>
			<div class="h-table h-mrt30">
				<el-table
				 ref="multipleTable"
				 @selection-change="handleSelectionChange"
				:data="tableData2"
				stripe
				style="width: 100%"
				:border="true"
				max-height="450"
				>
				<el-table-column
				  type="selection"
				  width="40"
				  label="全选"
				  >
				</el-table-column>
				<el-table-column
				  fixed
				  type="index"
				  label="#"
				  width="40">
				</el-table-column>
				<el-table-column
				  prop="contractName"
				  label="合同名称"
				   :show-overflow-tooltip="true"
				  min-width="180">
				  <template slot-scope="scope">
				  	<div style="text-align: left;">
				  		{{scope.row.contractName}}
				  	</div>
				  </template>
				</el-table-column>
				<el-table-column
				  prop="id"
				  label="合同编号"
				  :show-overflow-tooltip="true"
				  width="160">
				</el-table-column>
				<el-table-column
				  prop="customerName"
				  label="客户名称"
				  min-width="180"
				   :show-overflow-tooltip="true"
				  >
				  <template slot-scope="scope">
				  	<div style="text-align: left;">
				  		{{scope.row.customerName}}
				  	</div>
				  </template>
				</el-table-column>
				<!-- <el-table-column
				  prop="saleareaCode"
				  label="销售区域"
				  width="100">
				  <template slot-scope="scope">
				  		<dictname category="YlSalesArea" :v="scope.row.saleareaCode"/>
				  </template>
				</el-table-column> -->
				<el-table-column
				  prop="salechannelCode"
				  label="销售渠道"
				  width="90">
				  <template slot-scope="scope">
				  		<dictname category="sales_region" :v="scope.row.salechannelCode"/>
				  </template>
				</el-table-column>
				<el-table-column
				  prop="payCondition"
				  label="付款条件"
				   :show-overflow-tooltip="true"
				  width="90">
				</el-table-column>
				<el-table-column
				  prop="contractCatecory"
				  label="合同类型"
				   :show-overflow-tooltip="true"
				  width="90">
				  <template slot-scope="scope">
				  		<dictname category="contract_category" :v="scope.row.contractCatecory"/>
				  </template>
				</el-table-column>
				<el-table-column
				  prop="contractStatus"
				  label="合同状态"
				   width="90"
				  >
				</el-table-column>
				<el-table-column
				  prop="contractStarttime"
				  label="开始时间"
				   :show-overflow-tooltip="true"
				  width="100"
				  >
				</el-table-column>
				<el-table-column
				  prop="contractEndtime"
				  label="结束时间"
				   :show-overflow-tooltip="true"
				  width="100"
				  >
				</el-table-column>
				<el-table-column
				  label="操作"
				  width="280"
				  >
				  <template slot-scope="scope">
					  <!-- <router-link v-if="scope.row.editStatus===0"
						:to="{path:'/contract-new2',query:{id:scope.row.id}}"> -->
						<div style="text-align: left;">
							<el-button @click="adjustment(scope.row.id)"
							      type="text" v-if="scope.row.contractCatecory == 'CT-CG'"
							      size="small"
							      class="h-tableLink h-btn">
							            调整
							    </el-button>

							  	<el-button @click="editPage(scope.row.contractType, scope.row.id)"
							  	  type="text" v-if="scope.row.editStatus===0"
							  	  size="small"
							  	  class="h-tableLink h-btn">
							  			编辑
							  	</el-button>
							  <!-- </router-link> -->
							<router-link target="_blank" :to="{path: scope.row.id.indexOf('HTXS') != -1 ? '/contract-xs-detaili' : '/contract-detail', query: {key: scope.row.id}}">
								<el-button
								  type="text"
								  size="small"
								  class="h-tableLink h-btn">
										查看
								</el-button>
							</router-link>
							<el-button @click="ylcspage(scope.row)"
							  type="text"
							  v-if="scope.row.contractCatecory=='CT-ZL'&&scope.row.editStatus==1&&scope.row.ylcsFlag==0"
							  size="small"
							  class="h-tableLink h-btn">
									盈利测算
							</el-button>
							<el-button @click="freezeWindow(scope.row.id)"
							  type="text"
							  size="small"
							  v-if="scope.row.contractCatecory == 'CT-ZL'"
							  class="h-tableLink h-btn">
							        冻结/解除
							</el-button>
							<el-button @click="showcgdongjiewindow(scope.row.id)"
									   type="text"
									   size="small"
									   v-if="scope.row.contractCatecory == 'CT-CG' && scope.row.editStatus ==1"
									   class="h-tableLink h-btn">
								冻结/解除
							</el-button>
							<el-button
									type="text"
									size="small" class="h-tableLink h-btn"
                                    v-if="scope.row.instid"
									@click="genzongLiuch(scope.row.instid)">
								跟踪
							</el-button>

						</div>
				  </template>
				</el-table-column>
			  </el-table>

				<div class="h-tableB h-mrt30">
					<div class="h-tableBL">
						<el-button @click="exportExcel" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import">批量导出</el-button>
						<el-button v-auth="'createContract'" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-export" @click="uploaddownexcelflagbtn">批量导入</el-button>
						<uploaddownexcel :visible.sync="uploaddownexcelflag" v-if="uploaddownexcelflag" clsname="contractImportExcel"
						                 :startrow="3" @callback="uploadExcelFilecallback" />
					</div>
					<div class="h-pagination2">
						<pagination :page="q" @query="query" />
					</div>
				</div>
			</div>
            <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>

                <!-- 合同的冻结/解除 -->
                <el-dialog
                        :visible.sync="freezeX"
                        v-if="freezeX"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>合同冻结与恢复</h1>
                            </div>
                        </div>
                    </div>

                    <div style="margin: 0.3rem 0.2rem;">
                        <div class="h-pieceTitle2">
                            <h1>付款节点</h1>
                        </div>
                        <el-form ref="form3">
                        <el-table
                            ref="multipleTable"
                            :data="formInline.paymentList"
                            style="width: 100%"
							max-height="400"
                            >
                            <el-table-column
                            type="index"
                            width="40"
                            label="#">
                            </el-table-column>
                            <el-table-column
                            prop="nodeName"
                            label="节点名称"
                             :show-overflow-tooltip="true">
                                <template scope="scope">
                                    {{scope.row.nodeName}}
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="paymentRatio"
                            label="付款比例(%)" width="115">
                                <template scope="scope">
                                    {{scope.row.paymentRatio}}
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="paymentDays"
                            label="账期(天)"
                            width="115">
                                <template scope="scope">
                                    {{scope.row.paymentDays}}
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="freeze"
                            label="状态"
                            width="100">
                                <template scope="scope">
                                    <span v-if="scope.row.freeze==1">正常</span>
                                    <span v-if="scope.row.freeze==0">冻结中</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                            prop="freeze"
                            label="操作"
                            width="130">
                                <template scope="scope">
                                    <span v-if="scope.row.freeze==1">
                                        <el-button @click="exeFreeze(scope.row.id, scope.row.ccode, scope.row.posnr, '0')"
                                          type="text"
                                          size="small"
                                          class="h-tableLink h-btn">
                                                冻结
                                        </el-button>
                                    </span>
                                    <span v-if="scope.row.freeze==0">
                                        <el-button @click="exeFreeze(scope.row.id, scope.row.ccode, scope.row.posnr, '1')"
                                          type="text"
                                          size="small"
                                          class="h-tableLink h-btn">
                                                恢复
                                        </el-button>
                                    </span>
                                </template>
                            </el-table-column>
                        </el-table>
                        </el-form>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="freezeX = false">确 定</el-button>
                    </div>
                </el-dialog>

                <!-- 采购合同产品价格调整 -->
                <el-dialog
                        :visible.sync="adjustmentX"
                        v-if="adjustmentX"
                        class="h-dialog2"
                >
                    <div class="h-dialogImg">
                        <div class="h-disTable">
                            <div class="h-tableCell">
                                <h1>产品价格调整</h1>
                            </div>
                        </div>
                    </div>

                    <div style="margin:0.3rem 0.2rem">
                        <div class="h-pieceTitle2">
                            <h1>付款节点</h1>
                        </div>
                        <el-form ref="form3">
                             <el-table
                                    ref="multipleTable"
                                    :data="formInline.productList"
                                    style="width: 100%"
									max-height="400"
                                    >
                                    <el-table-column
                                    type="index"
                                    label="#" width="40">
                                    </el-table-column>
                                    <el-table-column
                                    prop="productId"
									:show-overflow-tooltip="true"
									width="120"
                                    label="产品型号">
                                    </el-table-column>
                                    <el-table-column
                                    prop="productName"
									width="140"
									:show-overflow-tooltip="true"
                                    label="产品名称">
                                    </el-table-column>
                                    <el-table-column
                                    prop="unitPrice"
                                    label="产品价格">
                                        <template scope="scope">
                                            <el-input v-model="scope.row.unitPrice" placeholder="" type="number" />
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                    prop="shuilv"
                                    label="发票税率">
                                        <template scope="scope">
                                            <brselect category="cgshuilv" :v="scope.row.shuilv" disabled v-model="scope.row.shuilv" />
                                        </template>
                                    </el-table-column>
                             </el-table>
                        </el-form>
                    </div>

                    <div slot="footer" class="dialog-footer">
                        <el-button class="h-btn h-bBtn h-bgwhite" @click="adjustmentX = false">取 消</el-button>
                        <el-button class="h-btn h-bBtn h-bgblue2" @click="exeAdjustment()">提交改动审批</el-button>
                    </div>
                </el-dialog>

			<!-- 采购合同产品冻结 -->
			<el-dialog
					:visible.sync="cgdongjiewindow"
					v-if="cgdongjiewindow"
					class="h-dialog2"
			>
				<div class="h-dialogImg">
					<div class="h-disTable">
						<div class="h-tableCell">
							<h1>采购合同冻结与解冻</h1>
						</div>
					</div>
				</div>

				<div style="margin: 0.3rem 0.2rem;">
					<div class="h-pieceTitle2">
						<h1>采购产品</h1>
					</div>
					<el-form ref="form3">
						<el-table
								ref="multipleTable"
								:data="cgdongjieList"
								style="width: 100%"
								max-height="400"
						>
							<el-table-column
									type="index"
									width="40"
									label="#">
							</el-table-column>
							<el-table-column
									prop="productName"
									label="产品名称"
									:show-overflow-tooltip="true">
								<template scope="scope">
									{{scope.row.productName}}
								</template>
							</el-table-column>
							<el-table-column
									prop="productId"
									label="产品编码" width="115">
								<template scope="scope">
									{{scope.row.productId}}
								</template>
							</el-table-column>
							<el-table-column
									prop="unitPrice"
									label="产品价格"
									width="115">
								<template scope="scope">
									{{scope.row.unitPrice}}
								</template>
							</el-table-column>
							<el-table-column
									prop="status"
									label="状态"
									width="100">
								<template scope="scope">
									<span v-if="scope.row.status==1">正常</span>
									<span v-if="scope.row.status==0">冻结中</span>
								</template>
							</el-table-column>
							<el-table-column
									prop="status"
									label="操作"
									width="130">
								<template scope="scope">
                                    <span v-if="scope.row.status==1">
                                        <el-button @click="freezeWindowCGDJ(scope.row.id)"
												   type="text"
												   size="small"
												   class="h-tableLink h-btn">
                                                冻结
                                        </el-button>
                                    </span>
									<span v-if="scope.row.status==0">
                                        <el-button @click="freezeWindowCGJD(scope.row.id)"
												   type="text"
												   size="small"
												   class="h-tableLink h-btn">
                                                解冻
                                        </el-button>
                                    </span>
								</template>
							</el-table-column>
						</el-table>
					</el-form>
				</div>

				<div slot="footer" class="dialog-footer">
					<el-button type="primary" @click="cgdongjiewindow = false">确 定</el-button>
				</div>
			</el-dialog>
			<contractadd :visible.sync="imgflag4" v-if="imgflag4" @imgfalse1="imgflag4=false" />
		</div>
	</div>
</template>

<script>
	import ss from "../../../api/SystemService";
	import updownfile from '../../../utils/updownfile';
	import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
    export default {
		components:{
		    uploaddownexcel,
		},
        name:'leftMenu',
        data() {
            return {
				cghetongid:null,
            	//冻结弹窗
				cgdongjiewindow:false,
				cgdongjieList:[],
				imgflag4:true,
				toshow:"hetongliebiao",
				status:1,
				checked:true,
				showhistory: false,
				showOrhide:false,
				freezeX: false,
				adjustmentX: false,
				//表单
                formInline:{},

				uploaddownexcelflag:false,
				hetongdex:0,
				hetonglist:[
					{
						title:"线下合同",
						desc:'线下所签署的合同，提供电子版上传',
					},
					{
						title:"LEG合同",
						desc:'LEG系统签署的合同，通过合同号关联',
					}
				],
				//表格
				 multipleSelection: [],
				 tableData2: [],

				//弹框
				dialogFormVisible:false,
				formLabelAlign2:{
					formCon1:'',
					formCon2:'',
					formCon3:'',
				},
				checkboxGroup1: ['亚太'],
				cities: ['非洲','亚太','UN'],
				q: {
				  pageSize: 10,
				  pageNo: 1,
				  total: 0,
				  idLike:"",
				  customerNameLike:"",
				  saleareaCodeLike:"",
				  salechannelCodeLike:""
				},
            }
        },
        	methods: {
				genzongLiuch(q){
				    this.instid = q;
					this.showhistory = true;
				},
				ylcspage(data){
					var url = this.$router.resolve({path: '/rateFormulaZulinshiti', query: {'cid':data.id,
						'z5':data.productCode,'z18':data.customerCode,'z20':data.customerName,
						'z7':data.rentTime,'z8':data.contractStarttime}});
					window.open(url.href, "_blank");
				},
				showzhezhao(){
					ss.salesList.toshow(this.toshow).then(rd => {
						console.log(rd)
					    if(rd == false){
					        this.showOrhide = false;
					    }else{
					        this.showOrhide = true;
					    }
					})
				},

                //加载冻结状态数据并弹窗
                freezeWindow(id) {
                    ss.contractService.detail(id).then(rd => {
                        this.formInline = rd.obj;
                        console.log(this.formInline);
                        this.freezeX = true;
                        sessionStorage.setItem("OBJ01", id);
                    });
                },

                //执行冻结/解除
                exeFreeze(id, cCode, posnr, flag) {
                    var cp = {
                        id : id,
                        cCode : cCode,
                        posnr : posnr,
                        flag : flag,
                    }
                    ss.contractService.doFreeze(cp).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.freezeWindow(sessionStorage.getItem("OBJ01"));
                    });
                },
				//采购产品弹窗
				showcgdongjiewindow(id) {
					this.cgdongjiewindow = true;
					this.cgproduct(id);
					this.cghetongid = id;
				},
				//查询采购产品
				cgproduct(v){
					ss.contractService.findCGProduct(v).then(rd => {
						this.cgdongjieList = rd;
					});
				},
				//冻结
				freezeWindowCGDJ(id) {
					ss.contractService.freezeWindowCGDJ(id).then(rd => {
						this.$msg.msgs(rd.msg);
						this.cgproduct(this.cghetongid);
					});
				},
				//解除
				freezeWindowCGJD(id) {
					ss.contractService.freezeWindowCGJD(id).then(rd => {
						this.$msg.msgs(rd.msg);
						this.cgproduct(this.cghetongid);
					});
				},

                //加载产品价格数据并弹窗
                adjustment(id) {
                    ss.contractService.detail(id).then(rd => {
                        this.formInline = rd.obj;
                        console.log(this.formInline);
                        this.adjustmentX = true;
                        sessionStorage.setItem("OBJ02", id);
                    });
                },

                //修改产品价格提交审批
                exeAdjustment() {
                    this.formInline.productListS = this.formInline.productList;
                    console.log(this.formInline.productListS);
                    ss.contractService.insertS(this.formInline).then(rd => {
                        this.$msg.msgs(rd.msg);
                        this.query();
                    });
                    this.adjustmentX = false;
                },

			uploadExcelFilecallback(){
				this.query();
			},
			//导入
			uploaddownexcelflagbtn(){
			    this.uploaddownexcelflag = true;
			},
			//重置
			resetData(){
				this.$refs["form"].resetFields();
			},
			//编辑
			editPage(contractType, id){
				var url;
				if (contractType == 0) {
					url = this.$router.resolve({path:"/contract-new2", query:{contractId:id}});
				} else {
					url = this.$router.resolve({path:"/contract-new1", query:{contractId:id}});
				}
				window.open(url.href, "_blank");
			},
			//导出
			exportExcel() {
			  var idlist=[];
			  this.multipleSelection.forEach(element => {
			    idlist.push(element.id);
			  });
			  this.q.ids = idlist.join(",");
			  updownfile.down("/api/swyl/v1/hetong/bscContract/downloadExcel",this.q);
			},
            //表格
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			hetongbtn(index){
				this.hetongdex = index;
			},
			queren(){
				if(this.hetongdex==0){
					this.$router.push("/contract-new2")
					this.dialogFormVisible=false
				}else{
					this.$router.push("/contract-new1")
					this.dialogFormVisible=false
				}
			},
			//查询列表
			query(p) {
			  ss.contractService.page(this.q).then(rd => {
			    this.q.total = rd.total;
			    this.tableData2 = rd.records;
			  });
			},
			handleFilter() {
			  this.query();
			},
			// 新手引导页
			nextStep(i){
				if(this.status ==1){
						this.status = 2;
				}else if(this.status ==2){
						this.status = 3;
				}else if(this.status ==3){
						this.status = 4;
				}else if(this.status ==4){
						this.status = 5;
				}else if(this.status ==5){
					if(this.checked){
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}else{
						ss.salesList.toshow(this.toshow,this.checked).then(rd => {
							console.log(rd)
							this.showOrhide = false;
						})
					}
				}

			},
			closeIt(){
				this.showOrhide = false;
				if(this.checked){
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}else{
					ss.salesList.toshow(this.toshow,this.checked).then(rd => {
						console.log(rd)
						this.showOrhide = false;
					})
				}
			  },
			xinzenghetong(){
				this.imgflag4 = true;
			}
		},
		mounted() {
			this.query();
		},
		created() {
			this.showzhezhao()
		}
    }
</script>
<style scoped lang="scss">
    .bottomTip{
		position: absolute;
		left: 49.7%;
		bottom: 0.3rem;
		transform: translateX(-50%);
	}
	.bottomTip2{
		position: absolute;
		left: 50%;
		bottom: 0.1rem;
		transform: translateX(-50%);
	}
	.newtext{
		font-size: 0.28rem;
		color: white;
		position: absolute;
		top:0.2rem;
		left: 50%;
		transform: translateX(-50%);
		font-weight: bold;
		text-shadow:1px 1px 4px #2785E7;
		z-index: 2;
	}
    .leaderBox{
		width: 100%;
		height: 100%;
		background-color: rgba(0,0,0,0.4);
		position: fixed;
		z-index: 99999;
		overflow: hidden;
		top: 0;
		left: 0;
		.leaderbg{
			width: 100%;
			height: 100%;
		}
		.steps{
			position: absolute;
			z-index: 1;
		}
		.step1{
			top: 0.78rem;
			left: 0rem;
			width: 4.3rem;
			height: 8.1rem;
		}
		.step2{
			top: 1.7rem;
			left: 2.95rem;
			width: 9rem;
			height: 1.6rem;
		}
		.step3{
			top: 1.75rem;
			width: 2.2rem;
			height: 1.7rem;
			right: 0.7rem;
		}
		.step4{
			top: 3.64rem;
			width: 3.6rem;
			height: 0.9rem;
			right: 0.6rem;
		}
		.step5{
			top: 8.4rem;
			width: 5.85rem;
			height: 0.9rem;
			left: 2.7rem;
		}
		.stepbtn{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.75rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.stepbtn1{
			width: 1.9rem;
			height: 0.6rem;
			border: 0.03rem solid #FFFFFF;
			background-color: rgba(0,0,0,0.1);
			border-radius: 5px;
			display: flex;
			justify-content: center;
			line-height: 0.5rem;
			position: absolute;
			z-index: 99;
			bottom: 0.45rem;
			left: 50%;
			transform: translateX(-50%);
			font-size: 0.27rem;
			letter-spacing: 2px;
			color: white;
			cursor: pointer;
		}
		.closeIt{
			width: 0.3rem;
			height: 0.3rem;
			position: absolute;
			top: 0.2rem;
			right: 0.2rem;
			cursor: pointer;
		}
	}
</style>
